
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-73a3c974!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./custom-modal-old.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./custom-modal-old.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-73a3c974!../../node_modules/vue-loader/lib/selector?type=template&index=0!./custom-modal-old.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/custom-modal-old.vue
// module id = 10
// module chunks = 0